Vue.component('content-video', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="lqd-column col-md-6">
                <br><br>
                <div
                class="liquid-img-group-container lqd-parallax-images-8"
                data-custom-animations="true"
                data-ca-options='{"triggerHandler":"inview", "animationTarget":".liquid-img-group-single", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"backward", "initValues":{"translateX":-85, "opacity":0}, "animations":{"translateX":0, "opacity":1}}'>
                    <div class="liquid-img-group-inner">

                        <div
                            class="liquid-img-group-single"
                            data-shadow-style="4"
                            data-roundness="8"
                            data-inview="true"
                            data-animate-shadow="true">
                            <div class="liquid-img-group-img-container">
                                <div
                                class="liquid-img-container-inner"
                                data-parallax="true"
                                data-parallax-from='{"translateY":78}'
                                data-parallax-to='{"translateY":-78}'
                                data-parallax-options='{"overflowHidden":false, "easing":"linear"}'>
                                    <figure class="w-90">
                                        <img src="./assets/demo/misc/fi-7.jpg" alt="Working with Ave" />
                                    </figure>
                                </div><!-- /.liquid-img-container-inner -->
                            </div><!-- /.liquid-img-group-img-container -->
                        </div><!-- /.liquid-img-group-single -->
                        
                        <div
                            class="liquid-img-group-single"
                            data-shadow-style="4"
                            data-roundness="8" data-inview="true" data-animate-shadow="true">
                            <div class="liquid-img-group-img-container">
                                <div class="liquid-img-group-content content-floated-mid">
                                    <a href="https://www.youtube.com/watch?v=vKSA_idPZkc" class="btn btn-naked fresco btn-icon-block btn-icon-top btn-icon-xlg btn-icon-circle btn-icon-solid">
                                        <span>
                                            <span class="btn-icon"><i class="fa fa-play"></i></span>
                                        </span>
                                    </a>
                                </div><!-- /.liquid-img-group-content -->
                                <div class="liquid-img-container-inner">
                                    <figure>
                                        <img src="./assets/demo/misc/fi-8.jpg" alt="Working with Ave" />
                                    </figure>
                                </div><!-- /.liquid-img-container-inner -->
                            </div><!-- /.liquid-img-group-img-container -->
                        </div><!-- /.liquid-img-group-single -->

                    </div><!-- /.liquid-img-group-inner -->
                </div><!-- /.liquid-img-group-container -->
                <br><br><br><br>
            </div><!-- /.lqd-column col-md-6 -->

            <div
                data-custom-animations="true"
                data-ca-options='{"triggerHandler":"inview", "animationTarget":"all-childs", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"forward", "initValues":{"translateY":30, "opacity":0}, "animations":{"translateY":0, "opacity":1}}'
                class="lqd-column col-md-5 col-md-offset-1">

                <header class="fancy-title mb-50">
                    <h6 class="text-uppercase">Check out our technology</h6>
                    <h2 class="lh-1 mb-0" data-fittext="true" data-fittext-options='{"compressor":0.65, "maxFontSize":"72", "minFontSize":"48"}'>Become a <strong class="sq-font">SpartaQuant</strong></h2>
                </header>

                <p class="font-size-18 lh-10 mb-25">We help our users and partners by providing the ultimate software to manage their daily activities.</p>
                <p class="font-size-18 lh-10 mb-25">It goes from data manipulation, model implementation, portfolio management, data sciences in general.</p>
                <p class="font-size-18 lh-10 mb-25">Find applications in our marketplace. There's something for every business challenge!</p>

                <a
                    href="#contactEnterprice"
                    class="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient font-weight-bold px-2"
                    data-lity="#contactEnterprice">
                    <span>
                        <span class="btn-gradient-bg"></span>
                        <span class="btn-txt">Start now</span>
                        <span class="btn-gradient-bg btn-gradient-bg-hover"></span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" class="btn-gradient-border" width="100%" height="100%">
                            <defs>
                                <linearGradient id="svg-border-2" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%"></stop>
                                    <stop offset="100%"></stop>
                                </linearGradient>
                            </defs>
                            <rect x="0.5" y="0.5" rx="29.5" ry="29.5" width="100%" height="100%" stroke="url(#svg-border-2)"></rect>
                        </svg>
                    </span>
                </a>

            </div><!-- /.lqd-column col-md-5 col-md-offset-1 -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        test: function(){

        }
    },
});